import JsonLd from '@/components/base/JsonLd';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://hipobuyspread.org';
const logoUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg';

export default function HomeSchema() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${siteUrl}/#website`,
    name: 'Hipobuy Spreadsheet',
    url: siteUrl,
    description: 'The ultimate product discovery and shopping guide — organized Hipobuy Spreadsheet resources, category comparisons, verified guides, and expert shopping strategies.',
    inLanguage: 'en-US',
    publisher: {
      '@id': `${siteUrl}/#organization`,
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${siteUrl}/#organization`,
    name: 'Hipobuy Spreadsheet',
    url: siteUrl,
    logo: {
      '@type': 'ImageObject',
      url: logoUrl,
      width: 512,
      height: 512,
    },
    sameAs: [
      'https://kaspreadsheet.com',
    ],
    description: 'Comprehensive spreadsheet shopping resource providing organized product discovery, category comparisons, and verified shopping guides across multiple platforms.',
    areaServed: {
      '@type': 'Country',
      name: 'United States',
    },
  };

  return (
    <>
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
    </>
  );
}